/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
    },
    registered () {
    },
    cached () {
    },
    updatefound () {
    },
    updated () {
    },
    offline () {
    },
    error (error) {
    }
  })
}

self.addEventListener('message', function(event) {
  if (event.data && event.data.command === 'clearCache') {

    self.addEventListener('activate', function(event) {
      event.waitUntil(
        caches.keys().then(function(cacheNames) {
          return Promise.all(
            cacheNames.map(function(cacheName) {
              // Check if the cache name should be cleared (e.g., clear all caches)
              if (cacheName.startsWith('Topli-Obrok')) {
                return caches.delete(cacheName);
              }
            })
          );
        })
      );
    });

  }
});
